import { useAppDispatch } from '@/core/redux/store';
import { toastService } from './toast-service';

/**
 * Hook to use toast service in components
 * Usage: const toast = useToast(); toast.showSuccess('Success!')
 */
export const useToast = () => {
  const dispatch = useAppDispatch();
  return toastService(dispatch);
};
